import React from "react";
import { Link } from "react-router-dom";

const PRIMARY = "btn-primary px-5 py-2.5 rounded text-sm font-semibold";
const SECONDARY =
  "px-5 py-2.5 rounded border border-white/10 text-white text-sm font-medium hover:bg-white/5 transition-colors";

// One shared block for all three "nothing to show" states (design sections
// 9.2 empty catalogue, 9.3 no results with filters, 9.4 error): "Replace
// with the same block" is section 9.4's own instruction. `actions` is at
// most 3 entries of {label, onClick} or {label, to}; the first is styled
// primary, the rest secondary.
export default function KitsEmptyState({ heading, body, actions = [] }) {
  return (
    <div className="mt-4 feature-card rounded-lg px-6 py-12 text-center">
      <h2 className="font-clash text-xl text-white">{heading}</h2>
      {body && <p className="mt-2 text-sm text-[#A1A1AA]">{body}</p>}
      {actions.length > 0 && (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {actions.map((action, i) => {
            const className = i === 0 ? PRIMARY : SECONDARY;
            return action.to ? (
              <Link key={action.label} to={action.to} className={className}>
                {action.label}
              </Link>
            ) : (
              <button key={action.label} type="button" onClick={action.onClick} className={className}>
                {action.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
